import React, { useEffect, useState, useReducer } from 'react'
import { useOrderDetailMutation } from '../../redux/services/orders/Orders'
import { useParams, useNavigate, Link as RouterLink } from 'react-router-dom';
import {
    Card, CardContent, Container, Grid, Typography, Box, Stack, Avatar,
    CardMedia,
    ListItemIcon,
    Tooltip,
    Button,
    Paper,
    Divider
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import Iconify from '../../components/iconify';
import Label from '../../components/label/Label';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { apiUrl } from '../../utils/api';
import UpdateOrders from './UpdateOrders';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineDot from '@mui/lab/TimelineDot';
import { createTheme } from '@mui/material/styles';
import { OrdersStatus, NumberFormatter } from '../../utils/helper';

const DataLogo = ({ name, path }) => {
    const url = `${apiUrl.Logo}${path}`;
    return (
        <Avatar alt={name} src={url} sx={{ width: 25, height: 25 }} />

    )
}

const ActionButton = ({ sellerInfo, id }) => {
    return (
        <>
            <Typography variant='subtitle1' sx={{ textDecoration: "none" }} component={RouterLink} to={`/seller-info/${id}`}>{sellerInfo}</Typography>
        </>
    )
}





const OrdersDetails = () => {
    const [getOrderDetails] = useOrderDetailMutation()
    const { id } = useParams()
    const [orderDetail, setOrderDetail] = useState()
    const navigate = useNavigate()
    const [loadData, setLoaddata] = useState(false)
    const [updateOrder, setUpdateOrder] = useState(null)
    const [reloadDdata, ForReloadData] = useReducer(x => x + 1, 0)

    console.log("OrderId", id)
    console.log("updatorder", updateOrder)

    const fatchOrderDetails = async () => {
        const body = {
            id: id
        }
        try {
            const result = await getOrderDetails(body)
            setOrderDetail(result.data)
            console.log("OrdersResult", result.data)
            setLoaddata(true)
        } catch (error) {
            console.log("error", error)
        }
    }

    useEffect(() => {
        fatchOrderDetails()
        console.log("orderDetail", orderDetail)

    }, [loadData, reloadDdata])

    const createdDate = new Date(orderDetail?.data?.created);
    const formattedCreated = createdDate.toLocaleString();

    const updatedDate = new Date(orderDetail?.data?.updated);
    const formattedUpdated = updatedDate.toLocaleString();

    const invoiceCreatedDate = new Date(orderDetail?.data?.invoice?.created);
    const invoiceFormattedCreated = invoiceCreatedDate.toLocaleString();

    const invoiceUpdatedDate = new Date(orderDetail?.data?.invoice?.updated);
    const invoiceFormattedUpdated = invoiceUpdatedDate.toLocaleString();



    const getStatusIcon = (status) => {
        switch (status) {
            case 'RDY':
                return <Iconify icon="mdi:food" width={20} />;
            case 'WAT':
                return <Iconify icon="ic:baseline-watch-later" width={20} height={20} />;
            case "COF":
                return <Iconify icon="ph:check-bold" width={20} height={20} />;
            case "PRE":
                return <Iconify icon="file-icons:precommit" width={20} height={20} />;
            case "OUT":
                return <Iconify icon="fluent:arrow-step-out-12-filled" width={20} height={20} />;
            case "DEL":
                return <Iconify icon="mdi:success-circle-outline" width={20} height={20} />;
            case "CAN":
                return <Iconify icon="ic:outline-cancel" width={20} height={20} />;
            case "SCH":
                return <Iconify icon="gridicons:scheduled" width={20} height={20} />;
            default:
                return null;
        }
    };

    const getStatusColor = (status) => {
        switch (status) {
            case "WAT":
                return "warning"
            case "COF":
                return "info"
            case "PRE":
                return 'info'
            case "RDY":
                return 'primary'
            case "OUT":
                return 'secondary'
            case "DEL":
                return 'success'
            case "CAN":
                return 'error'
            case "SCH":
                return 'secondary'
            default:
                return status;
        }
    }
    const getConnectorColor = (status) => {
        switch (status) {
            case 'WAT':
                return 'warning.main';
            case 'COF':
                return 'info.main';
            case 'PRE':
                return 'secondary.main';
            case 'RDY':
                return 'primary.main';
            case 'OUT':
                return 'secondary.main';
            case 'DEL':
                return 'success.main';
            case 'CAN':
                return 'error.main';
            case 'SCH':
                return 'secondary.main';
            default:
                return status;
        }
    }

    return (
        <>
            <Container maxWidth="xl" sx={{ marginTop: '10px' }}>
                <Card elevation={3} sx={{ padding: '20px' }}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between">

                        <Stack direction="row" >
                            <Button onClick={() => navigate("/dashboard/ordar")}>
                                <ListItemIcon >
                                    <ArrowBackIcon style={{ color: "blue" }} />
                                </ListItemIcon>
                            </Button>
                            <Typography variant='h4'>Order Details</Typography>
                        </Stack>
                        <Box sx={{ display: "flex", justifyContent: "end" }}>
                            <Button variant="contained" onClick={() => { setUpdateOrder(orderDetail.data) }}>Update Details</Button>
                        </Box>
                    </Stack>
                </Card>
            </Container>
            {/* <OrderDetailsPage {...orderDetail.data} OrdersStatus={OrdersStatus} /> */}
            <Container maxWidth="xl" sx={{ marginTop: "20px", }}>
                <Grid container spacing={2}>
                    <Grid item xs={4}>
                        {/* cutomer Card */}
                        <Card style={{ padding: '16px', }}>
                            <Stack direction="row" mb={1}>
                                <Iconify icon="ep:user" width={20} height={20} />
                                <Typography variant="h6">Customer</Typography>
                            </Stack>
                            <Box>
                                <Typography variant="subtitle2" color="gray">Name: </Typography>
                                <Typography variant="subtitle1">{orderDetail?.data?.user_name}</Typography>
                            </Box>
                            <Box>
                                <Typography variant="subtitle2" color="gray">Phone: </Typography>
                                <Typography variant="subtitle1">{orderDetail?.data?.phone}</Typography>
                            </Box>
                            <Box>
                                <Typography variant="subtitle2" color="gray">Address: </Typography>
                                <Typography variant="subtitle1">{orderDetail?.data?.address}</Typography>
                            </Box>
                            <Box>
                                <Typography variant="subtitle2" color="gray">LandMark: </Typography>
                                <Typography variant="subtitle1">{orderDetail?.data?.landmark}</Typography>
                            </Box>
                            <Box>
                                <Typography variant="subtitle2" color="gray">Area: </Typography>
                                <Typography variant="subtitle1">{orderDetail?.data?.area?.name}</Typography>
                            </Box>
                        </Card>
                        {/* user */}
                        <Card style={{ padding: '16px', marginTop: "10px" }} >
                            <Box >

                                <Stack direction="row" mb={2}>
                                    <Iconify icon="ep:user" width={20} height={20} />
                                    <Typography variant="h6">User Info</Typography>
                                </Stack>
                                <Grid container spacing={2}>
                                    <Grid item xs={8}>
                                        <Box>
                                            <Typography variant="subtitle2" color="gray">Name: </Typography>
                                            <Typography variant='subtitle1' sx={{ textDecoration: "none" }} component={RouterLink} to={`/user-orders/${orderDetail?.data?.user.accountId}`}>{orderDetail?.data?.user.first_name} {orderDetail?.data?.user.last_name}</Typography>

                                        </Box>
                                        <Box>
                                            <Typography variant="subtitle2" color="gray">Mobile: </Typography>
                                            <Typography variant="subtitle1">{orderDetail?.data?.user.mobile}</Typography>
                                        </Box>
                                        <Box>

                                            <Typography variant="subtitle2" color="gray">Email: </Typography>

                                            <Typography variant="subtitle1"> {orderDetail?.data?.user.email}</Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Box >
                                            <Stack direction="row" spacing={1}>
                                                <Typography variant="subtitle2" color="gray">Status: </Typography>
                                                {
                                                    // orderDetail?.data?.user.is_active ? <Typography variant="subtitle1" >Active</Typography> : < Typography variant="subtitle1" >Not Active</Typography>

                                                    orderDetail?.data?.user.is_active ? <Label color={("" === 'banned' && 'error') || 'success'}>Active</Label> : <Label color={("" === 'banned' && 'error') || 'error'}>Not Active</Label>
                                                }
                                            </Stack>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Card>
                    </Grid>
                    {/* seller Info */}
                    <Grid item xs={4}>
                        <Card sx={{ padding: "16px", height: "545px" }}>
                            <Box >
                                <Stack direction="row" mb={1}>
                                    <DataLogo path={orderDetail?.data?.seller.logo} />
                                    <Typography variant="h6">Seller Info</Typography>
                                </Stack>
                                <Grid container spacing={2}>
                                    <Grid item xs={7}>
                                        <Box>
                                            <Typography variant="subtitle2" color="gray"> Name: </Typography>
                                            <ActionButton sellerInfo={orderDetail?.data?.seller.business_name} id={orderDetail?.data?.seller.id} />
                                        </Box>
                                        <Box>
                                            <Typography variant="subtitle2" color="gray">Address: </Typography>

                                            <Typography variant="subtitle1">{orderDetail?.data?.seller.address}</Typography>
                                        </Box>
                                        <Box>
                                            <Typography variant="subtitle2" color="gray">Area: </Typography>

                                            <Typography variant="subtitle1">{orderDetail?.data?.seller.area.name}</Typography>
                                        </Box>
                                        <Box>
                                            <Typography variant="subtitle2" color="gray">Landmark: </Typography>
                                            <Typography variant="subtitle1">{orderDetail?.data?.seller.landmark}</Typography>
                                        </Box>
                                        <Box>
                                            <Typography variant="subtitle2" color="gray">Pincode: </Typography>
                                            <Typography variant="subtitle1">{orderDetail?.data?.seller.pincode}</Typography>
                                        </Box>
                                        <Box>
                                            <Typography variant="subtitle2" color="gray">City: </Typography>
                                            <Typography variant="subtitle1">{orderDetail?.data?.seller.city.name}</Typography>
                                        </Box>
                                        <Box>
                                            <Typography variant="subtitle2" color="gray">Latitude: </Typography>
                                            <Typography variant="subtitle1">{orderDetail?.data?.seller.loc_lat}</Typography>
                                        </Box>

                                        <Box>
                                            <Typography variant="subtitle2" color="gray">Longitude: </Typography>
                                            <Typography variant="subtitle1">{orderDetail?.data?.seller.loc_lon}</Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={5}>
                                                <Typography variant="subtitle2" color="gray">Approvel:</Typography>
                                            </Grid>
                                            <Grid item xs={3}>
                                                {
                                                    orderDetail?.data?.seller.verified ? <Label color={("" === 'banned' && 'error') || 'success'}>Verified</Label> : <Label color={("" === 'banned' && 'error') || 'error'}>Not Verified</Label>
                                                }
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2} sx={{ marginTop: '1px' }}>
                                            <Grid item xs={5}>
                                                <Typography variant="subtitle2" color="gray">Status: </Typography>
                                            </Grid>
                                            <Grid item xs={3}>

                                                {

                                                    orderDetail?.data?.seller.active ? <Label color={("" === 'banned' && 'error') || 'success'}>Active</Label> : <Label color={("" === 'banned' && 'error') || 'error'}>Not Active</Label>
                                                }
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>

                            </Box>
                        </Card>
                    </Grid>
                    {/* invoce */}
                    <Grid item xs={4}>
                        <Card sx={{ padding: "16px", height: "545px" }}>
                            <Box >
                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <Stack direction="row" mb={2}>
                                            <Iconify icon="iconamoon:invoice-bold" width={25} height={25} />
                                            <Typography variant="h6">Invoice</Typography>
                                        </Stack>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Stack direction="row" spacing={1} >
                                            <Typography variant="caption" color="gray" >
                                                Created :
                                            </Typography>
                                            <Typography variant="caption" >
                                                {invoiceFormattedCreated}
                                            </Typography>
                                        </Stack>
                                        <Stack direction="row" spacing={1}>
                                            <Typography variant="caption" color="gray" >
                                                Updated :
                                            </Typography>
                                            <Typography variant="caption"  >
                                                {invoiceFormattedUpdated}
                                            </Typography>
                                        </Stack>
                                        <Stack direction="row" spacing={1}>
                                            <Typography variant="subtitle2" color="gray">Status:</Typography>
                                            <Typography variant='subtitle1'>{OrdersStatus(orderDetail?.data?.invoice?.status)}</Typography>
                                        </Stack>
                                    </Grid>
                                </Grid>
                                <Box mt={2}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle2" color="gray">Invoice No:</Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1">{orderDetail?.data?.invoice?.invoice_no}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle2" color="gray">Transaction ID:</Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1">{orderDetail?.data?.invoice?.trans_id}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle2" color="gray">Reference Number:</Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1">{orderDetail?.data?.invoice?.ref_no}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle2" color="gray">Description:</Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1">{orderDetail?.data?.invoice?.description}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle2" color="gray">Access Code:</Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1">{orderDetail?.data?.invoice?.access_code}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle2" color="gray">Settled: </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant='subtitle1'>{
                                                orderDetail?.data?.invoice?.settled ? "Settled" : "Not Settled"
                                            }</Typography>
                                        </Grid>
                                    </Grid>

                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle2" color="gray">Paymet Status:</Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1">{orderDetail?.data?.invoice?.payload?.code}</Typography>
                                        </Grid>
                                    </Grid>

                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle2" color="gray">State:</Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1">{orderDetail?.data?.invoice?.payload?.data?.state}</Typography>
                                        </Grid>
                                    </Grid>

                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle2" color="gray">Merchant ID:</Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1">{orderDetail?.data?.invoice?.payload?.data?.merchantId}</Typography>
                                        </Grid>
                                    </Grid>
                                    {/* <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle2" color="gray">Response Code:</Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1">{orderDetail?.data?.invoice.payload.data.responseCode}</Typography>
                                        </Grid>
                                    </Grid> */}
                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle2" color="gray">Transaction ID:</Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1">{orderDetail?.data?.invoice?.payload?.data?.transactionId}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle2" color="gray">Pay Instrument:</Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1">{orderDetail?.data?.invoice?.payload?.data?.paymentInstrument?.utr}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle2" color="gray">Merchant ID:</Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1">{orderDetail?.data?.invoice?.payload?.data?.merchantTransactionId}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle2" color="gray">Message:</Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <Typography variant="subtitle1">{orderDetail?.data?.invoice?.payload?.message}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle2" color="gray">Success:</Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1">{orderDetail?.data?.invoice?.payload?.success ? "Success" : "Not Success"}</Typography>
                                        </Grid>

                                    </Grid>
                                    <Divider style={{ margin: "5px" }} />
                                    <Grid container spacing={2} >
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle2" color="gray">Amount:</Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1"><NumberFormatter number={orderDetail?.data?.invoice?.amount} /></Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle2" color="gray">Seller Amount:</Typography>

                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1"><NumberFormatter number={orderDetail?.data?.invoice?.seller_amount} /></Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle2" color="gray">Amount:</Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1"><NumberFormatter number={orderDetail?.data?.invoice?.payload?.data?.amount} /></Typography>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Box>
                        </Card>
                    </Grid>
                </Grid >


                <Card style={{ padding: '16px', marginTop: "20px", }}>
                    <Container maxWidth="lg">

                        <Stack direction="row" alignItems="center" justifyContent="space-between">
                            <Box marginLeft={0.5} >
                                <Stack direction="row" spacing={1}>
                                    <Typography variant="subtitle2" >
                                        Order ID :
                                    </Typography>
                                    <Typography variant="subtitle1" >
                                        {orderDetail?.data?.order_no}
                                    </Typography>
                                </Stack>
                                <Stack direction="row" spacing={1}>
                                    <Typography variant="caption" color="gray" >
                                        Created :
                                    </Typography>
                                    <Typography variant="caption" >
                                        {formattedCreated}
                                    </Typography>
                                </Stack>
                                <Stack direction="row" spacing={1}>
                                    <Typography variant="caption" color="gray" >
                                        Updated :
                                    </Typography>
                                    <Typography variant="caption"  >
                                        {formattedUpdated}
                                    </Typography>
                                </Stack>
                                <Stack direction="row" spacing={1}>
                                    <Typography variant="caption" color="gray">
                                        Status :
                                    </Typography>
                                    <ListItemIcon >
                                        {OrdersStatus(orderDetail?.data?.status)}
                                    </ListItemIcon>
                                </Stack>
                            </Box>
                            <Box >
                                <Stack direction="row" spacing={1} >
                                    <Typography variant="subtitle2" color="gray">
                                        Remark :
                                    </Typography>
                                    <Typography variant="subtitle2"  >
                                        {orderDetail?.data?.remark}
                                    </Typography>
                                </Stack>
                            </Box>
                        </Stack>
                        <Box mt={2} >
                            <Grid container spacing={3}>
                                <Grid item xs={6}>
                                    <Stack direction="row" mb={1}>
                                        <Iconify icon="icon-park-outline:transaction-order" width={20} height={20} />
                                        <Typography variant="h6">Order Info</Typography>
                                    </Stack>
                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle2" color="gray">Subtotal: </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1"><NumberFormatter number={orderDetail?.data?.sub_total} /></Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle2" color="gray">Order Total: </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1"><NumberFormatter number={orderDetail?.data?.order_total} /></Typography>
                                        </Grid>
                                    </Grid>

                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle2" color="gray">Min Order Charge: </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1"><NumberFormatter number={orderDetail?.data?.min_order_charge} /></Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle2" color="gray">Delivery Charge: </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1"><NumberFormatter number={orderDetail?.data?.delivery_charge} /></Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle2" color="gray">Discount Amount: </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1"><NumberFormatter number={orderDetail?.data?.discount_amount} /></Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle2" color="gray">GST: </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1"><NumberFormatter number={orderDetail?.data?.gst} /></Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle2" color="gray">Discount Code: </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1">{orderDetail?.data?.discount_code}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Stack direction="row" spacing={1}>
                                        <Typography variant="subtitle2" color="gray">Discount Description: </Typography>
                                        <Typography variant="subtitle1">{orderDetail?.data?.discount_description}</Typography>
                                    </Stack>
                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle2" color="gray">Scheduled: </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1">{orderDetail?.data?.scheduled}</Typography>
                                        </Grid>
                                    </Grid>

                                </Grid>
                                <Grid item xs={6}>

                                    <Stack direction="row" mb={1} >
                                        <Iconify icon="circum:delivery-truck" width={25} height={25} />
                                        <Typography variant="h6">Delivery</Typography>
                                    </Stack>

                                    <Grid container spacing={2}>
                                        <Grid item xs={3}>
                                            <Typography variant="subtitle2" color="gray">Postal Code: </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1">{orderDetail?.data?.del_postal}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={3}>
                                        <Grid item xs={3}>
                                            <Typography variant="subtitle2" color="gray">Distance: </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1">{orderDetail?.data?.del_distance}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={3}>
                                            <Typography variant="subtitle2" color="gray">Distance Fare: </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1">{orderDetail?.data?.del_distance_fare}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={3}>
                                            <Typography variant="subtitle2" color="gray">Fare per km: </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1">{orderDetail?.data?.del_fare_per_km}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={3}>
                                            <Typography variant="subtitle2" color="gray">Free Kms: </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1">{orderDetail?.data?.del_free_kms}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={3}>
                                            <Typography variant="subtitle2" color="gray">Latitude: </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1">{orderDetail?.data?.loc_lat}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={3}>
                                            <Typography variant="subtitle2" color="gray">Longitude: </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1">{orderDetail?.data?.loc_lon}</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Divider style={{ marginTop: '10px ' }} mt={2} />
                            <Grid container spacing={2} mt={2}>
                                <Grid item xs={6} >
                                    <Grid container spacing={2} >
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1" color="gray">Final Amount: </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="h6"><NumberFormatter number={orderDetail?.data?.final_amount} /></Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={4}>
                                    <Stack direction="row" mb={1}>
                                        <Iconify icon="fluent:payment-16-regular" width={25} height={25} />
                                        <Typography variant="h6">Payment Info</Typography>
                                    </Stack>
                                    <Grid container spacing={2}>
                                        <Grid item xs={5}>
                                            <Typography variant="subtitle2" color="gray">Payment Method: </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1">{orderDetail?.data?.mop}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={5}>
                                            <Typography variant="subtitle2" color="gray">Payment Status: </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1">{orderDetail?.data?.payment}</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>
                    </Container>
                </Card >

                {/* order info card */}
                <Grid container spacing={2} sx={{ marginTop: "12px" }} >
                    <Grid item xs={5}>
                        <Card>
                            <Timeline position="alternate">
                                {orderDetail?.data?.history?.map((item, index) => (
                                    <TimelineItem key={index}>
                                        <TimelineOppositeContent sx={{ m: 'auto 0' }} align="right" variant="body2" color="text.secondary">
                                            {new Date(item?.time).toLocaleTimeString()} {/* Format the time as needed */}
                                        </TimelineOppositeContent>
                                        <TimelineSeparator>
                                            <TimelineConnector sx={{ bgcolor: getConnectorColor(item?.status) }} />
                                            <TimelineDot color={getStatusColor(item?.status)}>
                                                {getStatusIcon(item?.status)}
                                            </TimelineDot>
                                            <TimelineConnector />
                                        </TimelineSeparator>
                                        <TimelineContent sx={{ py: '12px', px: 2 }}>
                                            <Typography variant="subtitle1" component="span">
                                                {item?.remark}
                                            </Typography><br />
                                            {OrdersStatus(item.status)}
                                        </TimelineContent>
                                    </TimelineItem>
                                ))}
                            </Timeline>
                        </Card>

                    </Grid>
                    {/* food items */}
                    <Grid item xs={7}>
                        <Card style={{ padding: '16px', }}>
                            <Stack direction="row" mb={1}>
                                <Iconify icon="mdi:food-outline" width={20} height={20} />
                                <Typography variant="h6">Food Item</Typography>
                            </Stack>

                            <TableContainer component={Paper}>
                                <Table sx={{ minWidth: 500 }} aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Name</TableCell>
                                            <TableCell align="right">Qty</TableCell>
                                            <TableCell align="right">Variant</TableCell>
                                            <TableCell align="right">Unit</TableCell>
                                            <TableCell align="right">Cost</TableCell>
                                            <TableCell align="right">Total</TableCell>
                                            <TableCell align="right">Food</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {orderDetail?.data?.items.map((item) => (
                                            <TableRow
                                                key={item.id}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell component="th" scope="row">
                                                    {item.name}
                                                </TableCell>
                                                <TableCell align="right">{item.qty}</TableCell>
                                                <TableCell align="right">{item.variant}</TableCell>
                                                <TableCell align="right">{item.unit}</TableCell>
                                                <TableCell align="right"> <NumberFormatter number={item.cost} /></TableCell>
                                                <TableCell align="right"><NumberFormatter number={item.total} /></TableCell>

                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                        </Card>
                    </Grid>
                </Grid>
                <br />

            </Container >
            <UpdateOrders update={updateOrder} setUpdate={setUpdateOrder} order={orderDetail} load={ForReloadData} />
        </>
    )
}

export default OrdersDetails
